/*
 * See the file LICENSE for the full license governing this code.
 */

import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import LoadingButton from '@mui/lab/LoadingButton';
import ErrorMessageWrapper from './ErrorMessageWrapper';

const trueFn = () => true;

export default function Form({
  Inputs,
  SecondaryAction,
  SuccessMessage,
  submitButtonProps: { sx: submitButtonSx, ...submitButtonProps } = {},
  SubmitButtonTitle,
  mutation,
  validate = trueFn,
}) {
  const { error, mutate: submit, isLoading, isSuccess } = mutation();
  return (
    <Box
      data-cy={SubmitButtonTitle}
      component="form"
      onSubmit={(e) => {
        e.preventDefault();
        if (validate()) {
          submit(e.nativeEvent);
        }
      }}
      sx={{ mt: 1 }}
    >
      {Inputs}
      <LoadingButton
        {...submitButtonProps}
        loading={isLoading}
        type="submit"
        fullWidth
        variant="contained"
        sx={{
          mt: 3,
          mb: 2,
          ...submitButtonSx,
        }}
      >
        {SubmitButtonTitle}
      </LoadingButton>
      {error && (
        <ErrorMessageWrapper containerStyles={{ justifyContent: 'center' }}>
          <Typography>{error.message}</Typography>
        </ErrorMessageWrapper>
      )}
      {isSuccess && SuccessMessage}
      {SecondaryAction}
    </Box>
  );
}
